var _path, _path2, _circle, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGambas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 105,
    viewBox: "0 0 113 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.2026 88.9999C131.703 38 70.7437 -16.2541 27.0002 8.99992C-19.6342 35.923 4.50006 113.5 66.5002 100C68.9419 99.3843 71.5005 97.9996 73.0003 95.9998C74.5002 94 75 86.9997 68 83.9997C68 83.9997 73.5 76.826 69.5 73.4997C65.5 70.1734 61.9997 69.4994 58.5 71.9997C55.0002 74.4999 51.5002 83.9997 40.0002 77.4999C30.2687 71.9997 32 57.4997 32 57.4997C34.4995 45.4995 42.5 41.4997 46.5 41.4997C50.5 41.4997 52.5 41.4997 57 46.9997C61.5 52.4997 83.2026 88.9999 83.2026 88.9999Z",
    fill: "#4BB3FF",
    stroke: "#02006D",
    strokeWidth: 5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0002 75.9999C88 83.5 95.5 89 101 86C106.5 83 109.5 69.4999 109.5 61.5C109.5 53.5001 101 25.5 111.5 4.5",
    stroke: "#02006D",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 90.0002,
    cy: 47.9999,
    r: 4,
    fill: "#02006D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0002 10.9999C53.9632 19.3808 55.0064 43.9999 55.0064 43.9999",
    stroke: "#02006D",
    strokeWidth: 5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0002 4.99988C30.0002 22.9999 31.5002 30.4999 42.0002 43.9999",
    stroke: "#02006D",
    strokeWidth: 5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.00024 46.9999C11.8151 55.7999 23.2225 59.3199 31.0002 57.5599",
    stroke: "#02006D",
    strokeWidth: 5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5 101C49.973 96.9412 48.3282 79 43 79",
    stroke: "#02006D",
    strokeWidth: 5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13 81.9955C23.4762 83.994 27.6667 83.4944 35 76",
    stroke: "#02006D",
    strokeWidth: 5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGambas);
export default __webpack_public_path__ + "static/media/gambas.913056e959f5d1eb873c134c53a79b4a.svg";
export { ForwardRef as ReactComponent };